import { render } from "./Status.vue?vue&type=template&id=b04bff02"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__